import Box from '@mui/material/Box';
import { Trans } from "react-i18next";
import TextField from '@mui/material/TextField';
import ProfileContext from './ProfileContext';

export default function () {

  return (
    <ProfileContext.Consumer>
      { context => {
        const company = context.company;
        return (<Box sx={{marginBottom: '15px', marginTop: '15px'}}>
          <Box className='profile-card-header'>
            <Box className='profile-card-title'>
              <Trans i18nKey={`screens.profile.sections.company.title`}></Trans>
            </Box>
          </Box>
          <Box className='profile-card-body'>
            <TextField
              label={<Trans i18nKey={`screens.profile.sections.company.companyLabel`}></Trans>}
              disabled
              fullWidth={true}
              defaultValue={company.name}
              variant="standard"
              className="profile informational"
            />
            <TextField
              label={<Trans i18nKey={`screens.profile.sections.company.addressLabel`}></Trans>}
              disabled
              fullWidth={true}
              defaultValue={company.streetAddress}
              variant="standard"
              className="profile informational"
              multiline
              maxRows={4}
              sx={{margin: '32px 0'}}
            />
            <TextField
              label={<Trans i18nKey={`screens.profile.sections.company.phoneLabel`}></Trans>}
              disabled
              fullWidth={true}
              defaultValue={company.phone}
              variant="standard"
              className="profile informational"
            />
            <TextField
              label={<Trans i18nKey={`screens.profile.sections.company.emailLabel`}></Trans>}
              disabled
              fullWidth={true}
              defaultValue={company.email}
              variant="standard"
              className="profile informational"
              sx={{marginTop: '32px'}}
            />
          </Box>
        </Box>)
      }}
    </ProfileContext.Consumer>
  );
}